import * as React from "react";
import cx from "classnames";
import { WrappedFieldArrayProps } from "redux-form";

import AbstractDropzone, { UploadedFileResponse } from "./AbstractDropzone";
import File, { DropzoneFile } from "./File";

interface DropzoneProps extends WrappedFieldArrayProps<DropzoneFile> {}

class DropzoneMulti extends AbstractDropzone<DropzoneProps> {
  private getCurrentState = () => this.props.fields.getAll() || [];

  private handleFileRemove = (index: number) => (
    e: React.SyntheticEvent<HTMLButtonElement>,
  ) => {
    e.stopPropagation();
    this.props.fields.remove(index);
  };

  protected getDropzoneClass = () =>
    cx("dropzone__container", {
      "dropzone__container--empty": this.props.fields.length === 0,
    });

  protected handleFinishedUpload = (res: UploadedFileResponse) =>
    this.props.fields.push({
      name: res.file.name,
      url: `https://${res.bucket}.s3.amazonaws.com/${res.objectKey}`,
    });

  protected renderContentFiles = () =>
    this.getCurrentState().map((file, i) => (
      <File key={i} onRemove={this.handleFileRemove(i)} {...file} />
    ));
}

export default DropzoneMulti;



// WEBPACK FOOTER //
// ./src/components/Dropzone/DropzoneMulti.tsx